import { __assign } from "tslib";
import { default as MuiSkeleton } from '@material-ui/lab/Skeleton';
import { createStyles, makeStyles } from '@material-ui/styles';
import React, { useEffect } from 'react';
var useStyles = makeStyles(function (theme) {
    var gradientColor = theme.palette.type === 'light' ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.4 )';
    return createStyles({
        wave: {
            '&::after': {
                background: "linear-gradient(90deg, transparent, ".concat(gradientColor, ", transparent)"),
            },
        },
    });
});
export var Skeleton = React.forwardRef(function (props, ref) {
    var _a = props.animation, animation = _a === void 0 ? 'timedWave' : _a;
    var styles = useStyles(props);
    var _b = React.useState('wave'), dynamicAnimation = _b[0], setDynamicAnimation = _b[1];
    useEffect(function () {
        setDynamicAnimation('wave');
        if (animation !== 'timedWave') {
            return undefined;
        }
        var timeoutId = setTimeout(function () {
            setDynamicAnimation(false);
        }, 3000);
        return function () {
            // Clean up the timeout in case the component is removed from the UI.
            clearTimeout(timeoutId);
        };
    }, [animation]);
    return (React.createElement(MuiSkeleton, __assign({ ref: ref, classes: {
            wave: styles.wave,
        } }, props, { animation: dynamicAnimation })));
});
export default Skeleton;
//# sourceMappingURL=Skeleton.js.map